import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import {
  BulkDeleteJobsRequest,
  IAllJobsResponse,
  IBulkDeleteJobsResponse,
} from "../models/Job";

// The full job list is only needed while the bulk delete modal is open, so it's fetched
// on demand rather than alongside the calendar.
export default function useBulkDeleteJobs(enabled: boolean = false) {
  const { get, post } = useApiHelper();
  const queryClient = useQueryClient();

  const allJobs = useQuery({
    queryKey: ["jobs", "all"],
    queryFn: () => get<IAllJobsResponse>("/job"),
    enabled,
  });

  const bulkRemove = useMutation(
    (req: BulkDeleteJobsRequest) =>
      post<BulkDeleteJobsRequest, IBulkDeleteJobsResponse>("/job/bulk-delete", req),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["jobs"]);
      },
    }
  );

  return {
    allJobs,
    bulkRemove,
  };
}
